import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'antd/dist/reset.css'; 
import "@/styles/index.less";

ReactDOM.render(<App />, document.getElementById("root"));

